/* =================== MÁSCARAS DOS CAMPOS =================== */

// VALOR
/* $(".valor").mask("000.000.000.000.000,00", { reverse: true }); */
// Valor
$(".valor")
  .maskMoney({
    prefix: "R$ ",
    thousands: ".",
    decimal: ",",
  })
  .on("change", function () {
    $(this).parsley().validate();
  })
  .on("keyup keydown keypress", function () {
    const $el = $('.campo-valor-txt[data-campo="#' + $(this).attr("id") + '"]');
    if ($el.length > 0) {
      const val = $(this).maskMoney("unmasked")[0];
      let desc = "Reais";
      let colorClass = "reais";
      if (val > 999999999.99) {
        desc = "Bilhões";
        colorClass = "bilhoes";
      } else if (val > 999999.99) {
        desc = "Milhões";
        colorClass = "milhoes";
      } else if (val > 999.99) {
        desc = "Mil";
        colorClass = "mil";
      }
      $el.removeClass("reais bilhoes milhoes mil").addClass(colorClass);
      $el.text(desc);
    }
  });

// CEP
$(".cep").mask("00000-000");

// DATA
$(".data").mask("00/00/0000");

$(".cpf").mask("000.000.000-00", { reverse: true });

// CPF
$(".cpf").mask("000.000.000-00", { reverse: true });

// CNPJ
$(".cnpj").mask("00.000.000/0000-00", { reverse: true });

// CPF OU CNPJ
var cpfCnpj = function (val) {
    return val.length > 14 ? "00.000.000/0000-00" : "000.000.000-009";
  },
  optionsDocumento = {
    onKeyPress: function (val, e, field, options) {
      field.mask(cpfCnpj(val), options);
    },
  };
$(".cpf-cnpj").mask(cpfCnpj, optionsDocumento);

// TELEFONE
var telefoneSP = function (val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(telefoneSP.apply({}, arguments), options);
    },
  };
$(".telefone").mask(telefoneSP, spOptions);

// CARTÃO DE CRÉDITO
$(".card-numero").mask("0000 0000 0000 0000", { reverse: true });

// CARTÃO DE CRÉDITO (VALIDADE)
$(".card-validade").mask("00/00");

// Tradução para o pluging 'Datepicker'
const datepickerLocaleBR = {
  format: "DD/MM/YYYY",
  separator: " a ",
  applyLabel: "Aplicar",
  cancelLabel: "Limpar",
  fromLabel: "De",
  toLabel: "a",
  daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  monthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
};

// ------------------------------------
// Datepicker
// ------------------------------------
(function () {
  "use strict";

  // Datepicker
  $(".datepicker").each(function () {
    const openDirection =
      $(this).data("direction") && $(this).data("direction") === "right"
        ? "left"
        : "right";
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        autoApply: true,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(picker.startDate.format("DD/MM/YYYY"));
        //$(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
      });
  });

  // Datepicker Range
  $(".datepicker_range").each(function () {
    const $campoChegada = $(this);
    const openDirection =
      $campoChegada.data("direction") &&
      $campoChegada.data("direction") === "right"
        ? "left"
        : "right";
    const $campoSaida = $($campoChegada.data("input-range"));
    $campoSaida.on("focus", function () {
      $campoChegada.focus();
    });
    $campoChegada
      .daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on("show.daterangepicker", function (ev, picker) {
        $campoSaida.addClass("active");
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $campoSaida.removeClass("active");
        $campoChegada.val(picker.startDate.format("DD/MM/YYYY"));
        $campoSaida.val(picker.endDate.format("DD/MM/YYYY"));
      })
      .on("hide.daterangepicker", function (ev, picker) {
        $campoSaida.removeClass("active");
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $campoSaida.removeClass("active");
        $campoChegada.val("");
        $campoSaida.val("");
      });
  });

  // Time Picker
  $(".timepicker").each(function () {
    const openDirection =
      $(this).data("direction") && $(this).data("direction") === "right"
        ? "left"
        : "right";
    const timepickerLocaleBR = datepickerLocaleBR;
    timepickerLocaleBR.format = "HH:mm";
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        autoUpdateInput: false,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on("show.daterangepicker", function (ev, picker) {
        picker.container.addClass("timepicker");
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(picker.startDate.format(timepickerLocaleBR.format));
        //$(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
      });
  });
})();
